import { createHtmlElement, ElementStyle } from './create-html-element';
import closeIcon from '../assets/icons/close-icon.svg';

const createCloseIconElement = (): HTMLImageElement => {
  const img = document.createElement('img');

  if (typeof closeIcon === 'string') {
    img.src = closeIcon;
  } else {
    const maybeImage = closeIcon as { src?: string } | undefined;

    if (maybeImage && typeof maybeImage.src === 'string') {
      img.src = maybeImage.src;
    } else {
      img.src = String(closeIcon);
    }
  }

  img.alt = 'Close';
  img.width = 16;
  img.height = 16;

  return img;
};

export const createCloseElement = () => {
  const styles: ElementStyle[] = [
    { property: 'position', value: 'absolute' },
    { property: 'right', value: '23px' },
    { property: 'top', value: '23px' },
    { property: 'width', value: '16px' },
    { property: 'height', value: '16px' },
    { property: 'opacity', value: '0.6' },
    { property: 'text-decoration', value: 'none' },
    { property: 'cursor', value: 'pointer' },
  ];
  const closeElement = createHtmlElement('a', styles);
  const iconElement = createCloseIconElement();
  closeElement.appendChild(iconElement);
  closeElement.id = 'close-button';

  return closeElement;
};
